/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrEmailType } from './irrEmailType';
import { IrrSendGridConfig } from './irrSendGridConfig';


export interface IrrEmailConfig { 
    type?: IrrEmailType;
    sendGridConfig?: IrrSendGridConfig;
}
export namespace IrrEmailConfig {
}


